import { Box, Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { NullData } from 'src/app/components/NullData';
import VideoItem from 'src/app/components/VideoItem';
import PlaybackDialog from './PlaybackDialog';


const Result = ({ isShowResult }) => {
  const [openVideo, setOpenVideo] = React.useState(false);
  const [dataPlayback, setDataPlayback] = React.useState({
    dirName: '',
    fileName: ''
  });

  const actionDetailsVideoRef = data => {
    setDataPlayback(data);
    setOpenVideo(true);
  };

  const listVod = useSelector(state => state.vodSlice.listVod);
  
  return (isShowResult && listVod) ? (
    <>
      <PlaybackDialog
        open={openVideo}
        setOpen={setOpenVideo}
        dataPlayback={dataPlayback}
      />

      <Box style={{ paddingRight: '30px' }}>
        {listVod?.length === 0 ? (
          <NullData />
        ) : (
          <Grid container spacing={3}>
            {listVod?.map((video, i) => (
              <Grid item key={video.id} lg={4} md={6} xs={12}>
                <VideoItem
                  actionDetailsVideoRef={actionDetailsVideoRef}
                  video={video}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </>
  ) : null;
};

Result.propTypes = {
  listVideos: PropTypes.array.isRequired,
  actionDetailsImgRef: PropTypes.func
};

export default Result;
